import { useContext } from 'react';

import loadingContext from 'contexts/loadingContext';

function useSnackbar() {
  return useContext(loadingContext);
}

export default useSnackbar;
